import { ChannelService } from './../../service/channel.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { TreeModule } from 'primeng/tree';
import { Category } from '../../category.type';
import { CategoryService } from '../../service/category.service';
import { UserService } from '../../../user/services/user.service';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { MappingWidgetCategoryComponent } from './mapping-widget/mapping-widget-category/mapping-widget-category.component';
import { ImportService } from '../../service/import.service';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MappingService } from '../mapping/mapping.service';
import { TooltipModule } from 'primeng/tooltip';
import { Message} from 'primeng/message';
import { MappingWidgetAttributeComponent } from './mapping-widget/mapping-widget-attribute/mapping-widget-attribute.component';
import { ToastModule } from 'primeng/toast';
import { MappingWidgetValueComponent } from './mapping-widget/mapping-widget-value/mapping-widget-value.component';
import { ShopService } from '../../../shop/service/shop.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MappingProduct } from '../../model/mappingProduct';
@Component({
  selector: 'app-import-workflow',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    TimelineModule,
    TagModule,
    TranslateModule,
    ButtonModule,
    DividerModule,
    Tabs, TabList, Tab, TabPanels, TabPanel,
    TreeModule,
    InputTextModule,
    DialogModule,
    ConfirmDialogModule,
    MappingWidgetCategoryComponent,
    TooltipModule,
    MappingWidgetAttributeComponent,
    MappingWidgetValueComponent,
    ToastModule,
    ProgressSpinnerModule,
    Message
  ],
  templateUrl: './import-workflow.component.html',
  styleUrl: './import-workflow.component.scss',
  providers: [TranslateService, ConfirmationService, MessageService],
})
export class ImportWorkflowComponent implements OnInit {
  toValidate = [];
  identified = [];
  unIdentified = [];

  toValidateAttributes = [];
  identifiedAttributes = [];
  unIdentifiedAttributes = [];

  identifiedValues = [];
  unIdentifiedValues = [];
  steps = [
    {
      id: 1,
      value: '1/6',
      label: 'importWorkflow.importSource',
      severity: 'secondary',
      text: 'importWorkflow.fileBeingAnalyzedMessage',
    },
    {
      id: 2,
      value: '2/6',
      label: 'importWorkflow.identification',
      severity: 'secondary',
      text: 'importWorkflow.identificationMessage',
    },
    {
      id: 3,
      value: '3/6',
      label: 'importWorkflow.matchingCategory',
      severity: 'secondary',
      text: 'importWorkflow.youHave',
      texts: [
        this.identified?.length,
        'importWorkflow.categoryIdentified',
        'global.and',
        this.unIdentified?.length,
        'importWorkflow.notIdentified'
      ],
    },
    {
      id: 4,
      value: '4/6',
      label: 'importWorkflow.matchingAttributes',
      severity: 'secondary',
      text: 'importWorkflow.matchingAttributesMessage',
    },
    {
      id: 5,
      value: '5/6',
      label: 'importWorkflow.matchingValues',
      severity: 'secondary',
      text: 'importWorkflow.matchingValuesMessage',
    },
    {
      id: 6,
      value: '6/6',
      label: 'importWorkflow.validation',
      severity: 'secondary',
      text: 'importWorkflow.validationMessage',
    },
  ];
  currentStep: any;
  categoriesForIdentified: Category[] = [];
  categoriesForUnidentified: Category[] = [];

  attributes: any[] = [];

  user;
  selectedNode;
  importId;
  attributesForValues;
  showMappingInterrumptedDialog = false;
  showSpinner = false;
  mappingValidated = false;
  identifiedFinal = 0;
  importShopCode;
  importLocale;
  countProductIdentified: number;
  countProductNotIdentified: number;

  @ViewChild('unIdentifiedMappingWidget') unIdentifiedMappingWidget: MappingWidgetCategoryComponent;
  @ViewChild('identifiedMappingWidget') identifiedMappingWidget: MappingWidgetCategoryComponent;

  @ViewChild('unIdentifiedMappingAttributeWidget') unIdentifiedMappingAttributeWidget: MappingWidgetAttributeComponent;
  @ViewChild('identifiedMappingAttributeWidget') identifiedMappingAttributeWidget: MappingWidgetAttributeComponent;

  @ViewChild('mappingValueWidget') mappingValueWidget: MappingWidgetValueComponent;

  constructor(
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly categoryService: CategoryService,
    private readonly channelService: ChannelService,
    private readonly userService: UserService,
    private readonly importService: ImportService,
    private readonly route: ActivatedRoute,
    private readonly confirmationService: ConfirmationService,
    private readonly mappingService: MappingService,
    private readonly messageService: MessageService,
    private readonly shopService: ShopService,

  ) {}

  ngOnInit(): void {
    const importId = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      this.importShopCode = params['importShopCode'];
      this.importLocale = params['importLocale'];
    })
    this.importId = importId;
    this.user = this.userService.getUser();
    this.checkImportMapping();
    this.importService.getImportHistory(this.importId).subscribe({
      next: (importHistory) => {
        if(importHistory.status == 'IN PROGRESS') {
          this.currentStep = this.steps[0];
        }else {
          this.currentStep = this.steps[1];
          this.initValues();
        }
        this.applyCorrectSeverity();
      }
    })

  }

  checkImportMapping() {
    this.mappingService.checkImportMapping(this.importId).subscribe({
      next: (res: boolean) => {
        if(res) {
          this.showMappingInterrumptedDialog = true;
          const data = {
            importId: this.importId,
            status: 'MAPPING_INTERRUPTED',
            message: "mapping interrompu"
          }
          this.mappingService.changeImportStatus(data).subscribe(); 
        }
      }
    })
  
  }
  initValues() {
    if (this.currentStep.id === 2) {
      this.getMappingPorducts()
      this.getIdentificationData();
      this.getMappingCategoryData();
      this.getMappingAttributeData();
    }
  }

  getMappingPorducts() {
    this.importService.getMappingProducts(this.importId, this.importShopCode).subscribe({
      next: (res: MappingProduct) => {
        this.countProductIdentified = res.countProductIdentified
        this.countProductNotIdentified = res.countProductNotIdentified
      }
    })
  }

  getMappingCategoryData() {
    this.categoryService.getCategories().subscribe({
      next: (res: any) => {
        const categoriesForUnidentified = structuredClone(res);
        const categoriesForIdentified = structuredClone(res);
        this.categoriesForUnidentified = this.categoryService.getCaterogyByLocale(
          categoriesForUnidentified,
          this.importLocale,
        );
        this.categoriesForIdentified = this.categoryService.getCaterogyByLocale(
          categoriesForIdentified,
          this.importLocale,
        );
        for (let node of this.categoriesForUnidentified) {
          this.handleSlectableNodes(node);
        }
        for (let node of this.categoriesForIdentified) {
          this.handleSlectableNodes(node);
        }
      },
    });
  }

  getMappingValues() {
    const importId = this.route.snapshot.paramMap.get('id');
    this.importId = importId;
    const data = {
      locale: this.channelService.getSelectedLocale(),
      vendorId: this.importShopCode,
      importId: this.importId
    }
    this.mappingService.getValuesMapping(data).subscribe({
      next: (res) => {
        this.attributesForValues = res;
      }
    })
  }

  getIdentificationData() {
    this.importService.getImportMapping(this.route.snapshot.paramMap.get('id')).subscribe({
      next: (res: any) => {
        this.toValidate = res['toValidate'];
        this.unIdentified = res['notIdentified'];
        this.identified = res['identified'];
      },
    });
  }

  handleSlectableNodes(node) {
    if (node.hasChildren == 'true') {
      node.selectable = false;
      for (let child of node.children) {
        this.handleSlectableNodes(child);
      }
    }
  }

  getMappingAttributeData() {
    const importId = this.route.snapshot.paramMap.get('id');
    this.importId = importId;
    this.mappingService.getAttributesMapping(importId).subscribe({
      next: (res: any) => {
        this.unIdentifiedAttributes = res['notIdentified'];
        this.identifiedAttributes = res['identified'];
      },
    });
  }

  applyCorrectSeverity() {
    for (const step of this.steps) {
      if (this.currentStep.id === step.id) {
        step.severity = 'info';
      } else if (this.currentStep.id > step.id) {
        step.severity = 'success';
      } else {
        step.severity = 'secondary';
      }
    }
  }

  nextStep() {
    if (this.currentStep.id === 2) {
      this.steps[2].texts = [
        this.identified?.length,
        'importWorkflow.categoryIdentified',
        'global.and',
        this.unIdentified?.length,
        'importWorkflow.notIdentified'
      ];
      this.handleStep();
    } else if (this.currentStep.id === 3) {
      this.finishMapping('category');
    } else if (this.currentStep.id === 4) {
      this.finishMapping('attribute');
    } else if (this.currentStep.id == 5) {
      this.finishMapping('value');
    } else {
      this.handleStep();
    }
  }

  handleStep() {
    const currentIndex = this.steps.indexOf(this.currentStep);
    this.currentStep = this.steps[currentIndex + 1];
    this.applyCorrectSeverity();
    this.initValues();
  }

  finishMapping(type) {
    this.confirmationService.confirm({
      message: this.translate.instant('importWorkflow.mappingConfirmationMessage'),
      header: this.translate.instant('global.confirmation'),
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: this.translate.instant('global.yes'),
      rejectLabel: this.translate.instant('global.no'),
      rejectButtonStyleClass: 'p-button-outlined',
      accept: () => {
        switch (type) {
          case 'category': this.finilizeCategoryMapping(); break;
          case 'attribute': this.finiliazeAttributeMapping(); break;
          case 'value': this.finiliazeValueMapping();
                        this.getFinalIdentifiedCategories();
                        break;
        }
      },
      reject: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('mapping.mappingCanceled'),
          life: 3000,
        });
      },
    });
  }

  finilizeCategoryMapping() {
    const unidentifiedMapping = this.unIdentifiedMappingWidget.finishMapping();
    const identifiedMapping = this.identifiedMappingWidget.finishMapping();
    const fullMapping = unidentifiedMapping
      .concat(identifiedMapping)
      .filter((mapping) => mapping.mappedTypologies.length > 0)
      .map((mapping) => {
        mapping.vendorId = this.importShopCode;
        mapping.fileId = mapping.importId;
        return mapping;
      });

    this.mappingService.saveCategoryMapping(fullMapping).subscribe({
      next: () => {
        this.handleStep();
      },
      error: () => {
        this.handleStep();
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('mapping.errorMapping'),
        });
      },
    });
  }

  finiliazeAttributeMapping() {
    const unidentifiedAttributeMapping = this.unIdentifiedMappingAttributeWidget.finishMapping();
    const identifiedAttributeMapping = this.identifiedMappingAttributeWidget.finishMapping();
    const fullMapping = unidentifiedAttributeMapping
      .concat(identifiedAttributeMapping)
      .filter((mapping) => mapping.mappedAttribute !== null && mapping.mappedAttribute !== '')
      .map((mapping) => {
        mapping.vendorId = this.importShopCode;
        mapping.importId = this.importId;
        return mapping;
      });

    this.mappingService.saveAttributeMapping(fullMapping).subscribe({
      next: () => {
        this.handleStep();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('mapping.errorMapping'),
        });
      },
    });
  }

  finiliazeValueMapping() {
    const fullMapping = this.mappingValueWidget.finishMapping();
    this.mappingService.saveValueMapping(fullMapping).subscribe({
      next: () => {
        this.handleStep();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('mapping.errorMapping'),
        });
      },
    })
  }
  navigate(url) {
    this.router.navigate([url]);
  }

  getFinalIdentifiedCategories() {
    this.mappingService.getFinalIdentifiedCategories(this.importId).subscribe({
      next: (value: number) => {
        this.identifiedFinal = value
      },
    })
  }


  accept() {
    this.showMappingInterrumptedDialog = false;
    this.navigate('/import/catalog-import')
  }

  validateMapping(skipErrors: boolean) {
    this.showSpinner = true;
    this.mappingValidated= true
    this.mappingService.validateMapping(this.importId, skipErrors).subscribe({
      next : (res: string) => {
        this.showSpinner = false;
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('messages.success'),
          detail: this.translate.instant('mapping.successMapping'),
        });
        setTimeout(() => this.navigate('/import/catalog-import'), 1000);
      },
      error: () => {
        this.showSpinner = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('messages.errorSummary'),
        });
      }
    })
  }

  validateImportWithoutHandlingErrors() {
    this.confirmationService.confirm({
      message: this.translate.instant('importWorkflow.confirmWithoutHandlingErrorTxt'),
      header: this.translate.instant('importWorkflow.confirmWithoutHandlingErrorTitle'),
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: this.translate.instant('buttons.confirm'),
      rejectLabel: this.translate.instant('buttons.cancel'),
      rejectButtonStyleClass: 'p-button-outlined',
      accept: () => {
        this.validateMapping(true);
      }
    });
  }
}
